import { Box, Button, CircularProgress, colors, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Header from '../components/Header'
import Tabs from '../components/Tabs'
import useQuery from '../components/useQuery'

// Sector Screen: autodraft status table for one sector, for the search the editor ran on the sector screen
const SectorStatus = () => {

    const history = useHistory()
    const query = useQuery()
    const sectorGroupId = query.get('sector_group_id')
    const date = query.get('date')
    const formType = query.get('form_type')
    const companyName = query.get('company_name')
    const country = query.get('country') || 'US'

    const [loading, setLoading] = useState(false)
    const [sectorName, setSectorName] = useState('')
    const [statusList, setStatusList] = useState([])

    useEffect(() => {
        setLoading(true)
        setStatusList([])
        axios.get(`/api/filings/sector-screen/status`, {
            params: {
                sector_group_id: sectorGroupId,
                date: date,
                form_type: formType,
                company_name: companyName,
                country: country,
            }
        }).then((resp) => {
            let { rows, sectors } = resp.data.message;
            console.log("Sector Status ::", resp.data.message)
            const sector = (sectors || []).find(sec => String(sec.sector_group_id) === String(sectorGroupId))
            setSectorName(sector ? sector.sector_group : '')
            setStatusList(rows || [])
        }).catch(err => console.log("Error :::", err))
            .finally(() => setLoading(false))
    }, [sectorGroupId, date, formType, companyName, country])

    // Back to the sector screen with the same search, so the editor lands where they were
    const backToSectorScreen = () => {
        const backQuery = new URLSearchParams()
        if (date) backQuery.append('date', date)
        if (formType) backQuery.append('form_type', formType)
        if (companyName) backQuery.append('company_name', companyName)
        if (country) backQuery.append('country', country)
        history.push(`/sector-screen?${backQuery.toString()}`)
    }

    return (
        <>
            <Header />
            <Tabs />
            <Box mx={1} my={1} textAlign='left'>
                <Button variant='outlined' color='secondary' size='small' onClick={backToSectorScreen}>Back</Button>
                <Typography variant='h6' color={colors.indigo[800]}>Sector -- {sectorName} | Autodraft Status</Typography>
                <Box fontSize={12} color={colors.blueGrey[500]}>
                    {/* Earlier implementation */}
                    {/* Date: {date || 'Today'}&nbsp;&nbsp;|&nbsp;&nbsp;Form Type: {formType || (country === 'IN' ? 'Quarterly' : '8-K')}{companyName ? <>&nbsp;&nbsp;|&nbsp;&nbsp;Company Name: {companyName}</> : null}{country === 'IN' ? <>&nbsp;&nbsp;|&nbsp;&nbsp;India</> : <>&nbsp;&nbsp;|&nbsp;&nbsp;US</>} */}
                    Date: {date || 'Today'}&nbsp;&nbsp;|&nbsp;&nbsp;Form Type: {formType || (country === 'IN' ? 'Quarterly' : '8-K')}{companyName ? <>&nbsp;&nbsp;|&nbsp;&nbsp;Company Name: {companyName}</> : null}{country === 'IN' ? <>&nbsp;&nbsp;|&nbsp;&nbsp;SEBI</> : <>&nbsp;&nbsp;|&nbsp;&nbsp;US</>}
                </Box>
            </Box>
            {/* Earlier implementation */}
            {/* <Box display='flex' justifyContent='flex-start' alignContent='center' alignItems='center' mx={1} px={1} py={0.5} my={0.5} fontSize={12} bgcolor={colors.blueGrey[100]}>
                <Box width='40%' fontWeight={700} textAlign="left">Company Name</Box>
                <Box width='15%' fontWeight={700} textAlign="center">Sector Priority</Box>
                <Box width='15%' fontWeight={700} textAlign="center">Form Type</Box>
                <Box width='15%' fontWeight={700} textAlign="center">Autodraft Published</Box>
                <Box width='15%' fontWeight={700} textAlign="center">Editor Article Published</Box>
            </Box> */}
            {/* Earlier implementation */}
            {/* <Box display='flex' justifyContent='flex-start' alignContent='center' alignItems='center' mx={1} px={1} py={0.5} my={0.5} fontSize={12} bgcolor={colors.blueGrey[100]}>
                <Box width='22%' fontWeight={700} textAlign="left">Company Name</Box>
                <Box width='24%' fontWeight={700} textAlign="left">Article URL</Box>
                <Box width='12%' fontWeight={700} textAlign="center">Sector Priority</Box>
                <Box width='12%' fontWeight={700} textAlign="center">Form Type</Box>
                <Box width='12%' fontWeight={700} textAlign="center">Autodraft Published</Box>
                <Box width='18%' fontWeight={700} textAlign="center">Editor Article Published</Box>
            </Box> */}
            <Box display='flex' justifyContent='flex-start' alignContent='center' alignItems='center' mx={1} px={1} py={0.5} my={0.5} fontSize={12} bgcolor={colors.blueGrey[100]}>
                <Box width='5%' fontWeight={700} textAlign="center">No.</Box>
                <Box width='20%' fontWeight={700} textAlign="left">Company Name</Box>
                <Box width='21%' fontWeight={700} textAlign="left">Article URL</Box>
                <Box width='12%' fontWeight={700} textAlign="center">Sector Priority</Box>
                <Box width='12%' fontWeight={700} textAlign="center">Form Type</Box>
                <Box width='12%' fontWeight={700} textAlign="center">Autodraft Published</Box>
                <Box width='18%' fontWeight={700} textAlign="center">Editor Article Published</Box>
            </Box>

            {loading ? <Box display="flex" justifyContent="center" alignItems="center" margin="15%"><CircularProgress /></Box> :
                <>
                    {statusList.length > 0 ?
                        <Box height={520} overflow="auto" px={1}>
                            {statusList.map((row, rowIndex) =>
                                <Box key={`${row.id}-${row.irk_omp}`} display="flex" justifyContent="flex-start" alignContent="center" alignItems="center"
                                    my={0.75} px={1} py={0.5} border={1} borderColor="#CCC" borderRadius={1} fontSize={12}>
                                    {/* Earlier implementation */}
                                    {/* <Box width='40%' textAlign="left">{row.company_confirmed_name || row.company_name}{row.ticker ? ` [${row.ticker}]` : ''}</Box> */}
                                    {/* <Box width='22%' textAlign="left">{row.company_confirmed_name || row.company_name}{row.ticker ? ` [${row.ticker}]` : ''}</Box> */}
                                    {/* <Box width='24%' textAlign="left" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}> */}
                                    {/* Row number is gray and sits in its own column, away from Sector Priority. */}
                                    <Box width='5%' textAlign="center" color={colors.blueGrey[500]}>{rowIndex + 1}</Box>
                                    <Box width='20%' textAlign="left">{row.company_confirmed_name || row.company_name}{row.ticker ? ` [${row.ticker}]` : ''}</Box>
                                    <Box width='21%' textAlign="left" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {row.article_url ?
                                            <a href={row.article_url} target='_blank' rel='noreferrer' title={row.article_url} style={{ color: colors.blue[800] }}>{row.article_url}</a>
                                            : null}
                                    </Box>
                                    <Box width='12%' textAlign="center">{row.sector_priority}</Box>
                                    <Box width='12%' textAlign="center">{row.form_type}</Box>
                                    <Box width='12%' textAlign="center">{row.autodraft_published}</Box>
                                    {/* Earlier implementation */}
                                    {/* <Box width='15%' textAlign="center">{row.editor_article_published}</Box> */}
                                    {/* Polished: Yes / editor name. Not polished: No. USinMinutes and INminutes are not shown. */}
                                    <Box width='18%' textAlign="center">{row.editor_article_published === 'Yes' && row.author_name ? `Yes / ${row.author_name}` : (row.editor_article_published === 'Yes' ? 'Yes' : 'No')}</Box>
                                </Box>
                            )}
                        </Box>
                        : <Box width="100%" textAlign="center" my={5}>
                            <Typography variant='body1' color={colors.deepOrange[300]}>No results found</Typography>
                        </Box>
                    }
                </>}
        </>
    )
}

export default SectorStatus
